import React from 'react';
import { Icon } from 'antd';

import styles from '../styles.module.scss';

export const Header = ({ date, onChange }) => (
  <div className={styles.header}>
    <button
      type="button"
      className={styles.header__button}
      onClick={() => onChange(date.clone().subtract(1, 'month').date(1))}
    >
      <Icon type="left" theme="outlined" />
    </button>

    <span className={styles.header__date}>
      {date.format('MMMM YYYY')}
    </span>

    <button
      type="button"
      className={styles.header__button}
      onClick={() => onChange(date.clone().add(1, 'month').date(1))}
    >
      <Icon type="right" theme="outlined" />
    </button>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Agenda/Calendar/Header/index.js